import styled from "styled-components";

import { fontFamilyDefault } from "@/styles/typography";

export const TableCell = styled.div`
  text-transform: capitalize;
  font-family: ${fontFamilyDefault};
`;

export const customTableStyles = {
  rows: {
    style: {
      backgroundColor: "#FEFAF1",
      "&:hover": {
        background: "#fff6e3",
        boxShadow: "5px 0px 5px rgba(0,0,0,0.2)",
      },
      fontFamily: fontFamilyDefault,
      padding: "5px",
      justifyContent: "space-evenly",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#FAF6F4",
      fontWeight: 400,
      fontSize: 12,
      lineHeight: "22px",
      fontFamily: fontFamilyDefault,
      justifyContent: "space-evenly",
    },
  },
};
